export interface NavItem {
  id: number;
  title: string;
  description: string;
  icon: any;
  themeColor?: string;
  path: string;
  sub_path?: string;
}
export const AdminNav: NavItem[] = [
  {
    id: 1,
    title: "Home",
    description: "",
    icon: <span className="material-symbols-outlined">home </span>,
    themeColor: "",
    path: "/admin",
  },
  {
    id: 2,
    title: "Create Template",
    description: "Create and Edit Template",
    icon: <span className="material-symbols-outlined">add_circle</span>,
    themeColor: "primary",
    path: "createtemplate",
  },
  {
    id: 3,
    title: "Template Library",
    description: "Manage and Assign Templates to Students",
    icon: <span className="material-symbols-outlined">assignment </span>,
    themeColor: "warning",
    path: "templatelibrary",
    sub_path: "template",
  },
  {
    id: 4,
    title: "Manage Role and Permission",
    description: "View User Details by Role and Status",
    icon: <span className="material-symbols-outlined">person</span>,
    themeColor: "success",
    path: "managerole",
  },
  {
    id: 5,
    title: "Archive",
    description: "Archive existing Student & Tutor profiles",
    icon: <span className="material-symbols-outlined">archive</span>,
    themeColor: "info",
    path: "archive",
  },
];
